import React, { useEffect, useState } from "react";
import {
  Button,
  Offcanvas,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import useForm from "../../hooks/useForm";
import {
  WallpaperOutlined,
  FormatAlignCenterOutlined,
  FormatAlignLeftOutlined,
  FormatAlignRightOutlined,
  AddOutlined,
  ModeEditOutlined,
} from "@mui/icons-material";
import useHome from "../../hooks/useHome";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import { formatearFecha } from "../../helpers/formatearFecha";
import toast from "react-hot-toast";
import useAudit from "../../hooks/useAudit";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SidebarSlides = ({ replicaPgi, isEdit, sliderToEdit = null }) => {
  const { setFlag, flag, addCategory, getCategories, categories } =
    useHome();
  const { createAuditRequest } = useAudit();
  const [showEditSlide, setShowEditSlide] = useState(false);
  const [dateArt, setDateArt] = useState(false);
  const [modalFor, setModalFor] = useState(null);
  const handleCloseSlide = () => setShowEditSlide(false);
  const handleShowSlide = () => setShowEditSlide(!showEditSlide);
  const [mainH1, setMainH1] = useState(isEdit ? sliderToEdit.mainH1 : false);

  useEffect(() => {
    getCategories();
  }, []);

  const handleArtDateYes = () => setDateArt(true);
  const handleArtDateNo = () => setDateArt(false);
  const user = JSON.parse(localStorage.getItem('Usuario'))?.UserLogin?.name
  const {
    values,
    setValues,
    categoria,
    handleInputChange,
    handleSectionSelectChange,
    handleTagSelectchange,
    handleRadioChange,
  } = useForm({
    section: isEdit ? sliderToEdit?.section : "",
    title: isEdit ? sliderToEdit?.title : "",
    content: isEdit ? sliderToEdit?.content : "",
    content_mobile: isEdit ? sliderToEdit?.content_mobile : "",
    link: isEdit ? sliderToEdit?.link : "",
    publishedDate: isEdit ? sliderToEdit?.creation_date : "",
    tags: isEdit ? sliderToEdit?.tags : [],
    state: isEdit ? sliderToEdit?.state : true,
    publish: false,
    image_desktop: isEdit ? sliderToEdit?.image_desktop : [],
    image_tablet: isEdit ? sliderToEdit?.image_tablet : [],
    image_mobile: isEdit ? sliderToEdit?.image_mobile : [],
    align: isEdit ? sliderToEdit?.align : "",
    deleted: false,
    deleted_date: isEdit ? sliderToEdit?.deleted_date : null,
    element: 0,
    // updated_date: isEdit ? sliderToEdit?.updated_date : null,
    creator: user, // se debe ingresar el nombre del usuario creador
    mainH1: isEdit ? sliderToEdit.mainH1 : false
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    let imageDesktopValidation = false;

    if (values.image_desktop.length <= 0) {
      toast.error("La Imagen es Requerida");
    } else {
      imageDesktopValidation = true;
    }

    if (imageDesktopValidation) {
      if (isEdit) {
        addCategory(categoria);
        createAuditRequest({
          ...sliderToEdit,
          content: values.content,
          content_mobile: values.content_mobile,
          link: values.link,
          publishedDate: values.publishedDate,
          section: values.section,
          state: values.state,
          publish: false,
          image_desktop: values.image_desktop,
          image_tablet: values.image_tablet,
          image_mobile: values.image_mobile,
          tags: values.tags,
          title: values.title,
          align: values.align,
          includeDate: dateArt,
          creator: user,
          mainH1: mainH1,
          element: 0,
          updated_date: String(
            new Date().getFullYear() +
            "-" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "-" +
            new Date().getDate()
          ).padStart(2, "0"),
        }, 'EDIT');
      } else {
        addCategory(categoria);
        createAuditRequest({
          ...values,
          publishedDate: "",
          includeDate: dateArt,
          image_desktop: values.image_desktop,
          image_tablet: values.image_tablet,
          image_mobile: values.image_mobile,
          element: 0,
          creator: user,
          mainH1: mainH1,
          creation_date: String(
            new Date().getFullYear() +
            "-" +
            String(new Date().getMonth() + 1).padStart(2, "0") +
            "-" +
            new Date().getDate()
          ).padStart(2, "0"),
          _id: String(
            Math.ceil(
              Math.random() * (999999999999 - 100000000000) + 100000000000
            )
          ),
        });
        setFlag(!flag);
      }
      setShowEditSlide(!showEditSlide);
    }
  };

  // MODAL GALERIA
  const [showGaleria, setShowGaleria] = useState(false);
  const handleCloseGaleria = () => setShowGaleria(false);
  const handleShowGaleria = () => setShowGaleria(true);

  const handleModalClick = (modalFor) => {
    setModalFor(modalFor);
    handleShowGaleria();
  };

  return (
    <>
      <div className="pgi__sidebar-slides">
        {replicaPgi ? (
          <button
            className="botton-editar-pgi settings_button-pleno"
            onClick={handleShowSlide}
          >
            Agregar Slide
          </button>
        ) : (
          <>
            <OverlayTrigger
              key="1"
              placement="top"
              overlay={
                <Tooltip id="1">
                  {isEdit ? "Editar Slide" : "Nuevo Slide"}
                </Tooltip>
              }
            >
              <Button
                className="btn-form-pgi"
                variant="light"
                onClick={handleShowSlide}
              >
                {isEdit ? <ModeEditOutlined /> : <AddOutlined />}
              </Button>
            </OverlayTrigger>
          </>
        )}

        <Offcanvas
          show={showEditSlide}
          onHide={handleCloseSlide}
          className="basePgi__pgi  pgi__sidebar-container"
          placement="end"
          scroll="false"
          backdrop={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              Home / {isEdit ? <b>EDITAR SLIDE </b> : <b>CREAR SLIDE</b>}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <form onSubmit={handleSubmit}>
              <button
                type="submit"
                className="settings_button-pleno float-end botton-save-pgi"
              >
                GUARDAR
              </button>
              <div className="pgi__sidebar-container-items form-group w-100">
                <div className="mt-1">
                  <label htmlFor="section">Sección</label>
                  <CreatableSelect
                    isClearable
                    name="title"
                    placeholder="Indicar Sección"
                    maxLength="30"
                    onChange={handleSectionSelectChange}
                    options={
                      categories
                        ? categories?.map((slider) => ({
                          value: slider.title,
                          label: slider.title,
                        }))
                        : ""
                    }
                    defaultValue={{ value: sliderToEdit?.section, label: sliderToEdit?.section }}
                  />
                </div>
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    id="title"
                    value={values.title}
                    onChange={handleInputChange}
                    placeholder="..."
                    required
                    maxLength={70}
                    minLength={3}
                  />
                  <label htmlFor="title">TÍtulo del slide</label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 70.</span>
                  </p>
                </div>

                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="content"
                    id="content"
                    value={values.content}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={240}
                    minLength={3}
                  />
                  <label htmlFor="content">Descripción</label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 240.</span>
                  </p>
                </div>
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="content_mobile"
                    id="content_mobile"
                    value={values.content_mobile}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={100}
                    minLength={3}
                  />
                  <label htmlFor="content_mobile">Descripción para dispositivos móviles</label>
                  <p className="basePgi__comments">
                    <span>Máximo de caracteres: 100.</span>
                  </p>
                </div>
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="link"
                    id="link"
                    value={values.link}
                    onChange={handleInputChange}
                    placeholder="..."
                    maxLength={120}
                  />
                  <label htmlFor="link">Enlace a...</label>
                  <p className="basePgi__comments">
                    Ejemplo: /donde-comprar
                  </p>
                </div>
                <div className="form-floating">
                  <div
                    className="pgi__container-img"
                    style={{ display: "none" }}
                  >
                    {/*implementar selector de images *** eliminar style={{}} al agregar imagenes*/}
                  </div>
                  {/*implementar: al editar banner cambiar x "REEMPLAZAR"*/}
                  {/* MODAL GALERIA */}
                  <Modal
                    id="galleryModal"
                    className="modalContenedor__galeria"
                    show={showGaleria}
                    onHide={handleCloseGaleria}
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                      <GaleriaPgiModal
                        editProduct={values}
                        setEditProduct={setValues}
                        modalFor={modalFor}
                        handleCloseGaleria={handleCloseGaleria}
                      />
                    </Modal.Body>
                  </Modal>
                  <article className="d-flex ">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("image_desktop")}
                    >
                      Imagen desktop
                      <WallpaperOutlined />
                    </Button>
                    {isEdit && (
                      <>
                        <p className="m-auto w-50">
                          {sliderToEdit?.image_desktop?.length === 0 && (
                            <h5 className="mx-3">
                              No hay imágenes seleccionadas
                            </h5>
                          )}
                          {sliderToEdit?.image_desktop?.map((img, index) => (
                            <h5 className="mx-3" key={index}>
                              - {img.title ? img.title : "Imagen Seleccionada"}{" "}
                              || {img.filename}
                            </h5>
                          ))}
                        </p>
                      </>
                    )}
                  </article>
                  <p className="basePgi__comments">
                    <span>
                      Imagen para Escritorio (.jpg, .png). Proporción 16:9.
                      Ancho máximo 2048px
                    </span>
                  </p>
                  <article className="d-flex ">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("image_tablet")}
                    >
                      Imagen tablet
                      <WallpaperOutlined />
                    </Button>
                    {isEdit && (
                      <>
                        <p className="m-auto w-50">
                          {sliderToEdit.image_tablet?.length === 0 && (
                            <h5 className="mx-3">
                              No hay imágenes seleccionadas
                            </h5>
                          )}
                          {sliderToEdit.image_tablet?.map((img, index) => (
                            <h5 className="mx-3" key={index}>
                              - {img.title ? img.title : "Imagen Seleccionada"}{" "}
                              || {img.filename}
                            </h5>
                          ))}
                        </p>
                      </>
                    )}
                  </article>
                  <p className="basePgi__comments">
                    <span>
                      Imagen para Tablet - Notebook (.webP, .jpg, .png).
                      Proporción 4:3. Ancho máximo 2048px
                    </span>
                  </p>
                  <article className="d-flex ">
                    <Button
                      className="btn-form-pgi pgi__head-modules shadow-sm w-50"
                      onClick={() => handleModalClick("image_mobile")}
                    >
                      Imagen mobile
                      <WallpaperOutlined />
                    </Button>
                    {isEdit && (
                      <>
                        <p className="m-auto w-50">
                          {sliderToEdit.image_mobile?.length === 0 && (
                            <h5 className="mx-3">
                              No hay imágenes seleccionadas
                            </h5>
                          )}
                          {sliderToEdit.image_mobile?.map((img, index) => (
                            <h5 className="mx-3" key={index}>
                              - {img.title ? img.title : "Imagen Seleccionada"}{" "}
                              || {img.filename}
                            </h5>
                          ))}
                        </p>
                      </>
                    )}
                  </article>
                  <p className="basePgi__comments">
                    <span>
                      Imagen Mobile (.webP, .jpg, .png). Proporción 9:16. Ancho
                      máximo 2048px
                    </span>
                  </p>
                </div>
                <hr />
                <div className="pgi__select-align-text">
                  <p>Alineación de pastilla</p>
                  {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-left" <div className="carousel align-left"></div> */}
                  <Form.Check
                    defaultChecked={
                      sliderToEdit?.align === "align-left" && true
                    }
                    inline
                    label={<FormatAlignLeftOutlined />}
                    name="align"
                    type="radio"
                    id="align-left"
                    value="align-left"
                    onChange={handleRadioChange}
                  />
                  {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-center" <div className="carousel align-center"></div> */}
                  <Form.Check
                    defaultChecked={
                      sliderToEdit?.align === "align-center" && true
                    }
                    inline
                    label={<FormatAlignCenterOutlined />}
                    name="align"
                    type="radio"
                    id="align-center"
                    value="align-center"
                    onChange={handleRadioChange}
                  />
                  {/* determina ALINEACION DEL BLOQUE DE TXT en pantalla, INCORPORAR el class "align-right" <div className="carousel align-right"></div> */}
                  <Form.Check
                    defaultChecked={
                      sliderToEdit?.align === "align-right" && true
                    }
                    inline
                    label={<FormatAlignRightOutlined />}
                    name="align"
                    type="radio"
                    id="align-right"
                    value="align-right"
                    onChange={handleRadioChange}
                  />
                </div>
                <hr />
                <h3 className="basePgi__comments">Incluir Fecha:</h3>
                <div className="d-block">
                  <Form.Check
                    defaultChecked={sliderToEdit?.includeDate === true && true}
                    inline
                    label="Si"
                    name="type"
                    type="radio"
                    onClick={handleArtDateYes}
                  />
                  <Form.Check
                    defaultChecked={sliderToEdit?.includeDate === false && true}
                    inline
                    label="No"
                    name="type"
                    type="radio"
                    onClick={handleArtDateNo}
                  />
                </div>
                {isEdit && (
                  <div className="form-floating mt-2">
                    <p>
                      Fecha de publicacion:{" "}
                      {formatearFecha(values?.publishedDate)}
                    </p>
                  </div>
                )}

                <div>
                  <label htmlFor="tags">Tags</label>
                  <CreatableSelect
                    options={
                      isEdit &&
                      sliderToEdit.tags.map((tag) => ({
                        label: tag,
                        value: tag,
                      }))
                    }
                    id="tags"
                    isClearable
                    isMulti
                    onChange={handleTagSelectchange}
                    placeholder="Tags"
                  />
                </div>
                <div id="mainH1Container">
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 className="basePgi__comments">h1 de pagina:</h3>
                    <OverlayTrigger
                        key="1"
                        placement="top"
                        overlay={
                        <Tooltip id="1">
                          Al seleccionar esta opción, la noticia actual permanecerá como el título principal (h1) de la página.<br />
                          <strong>NOTA:</strong> Si ya hay otra noticia marcada como título principal, se actualizará por esta selección.
                        </Tooltip>}
                      >
                        <InfoOutlinedIcon className="mb-3"/>
                    </OverlayTrigger>
                  </div>
                  <div className="d-block">
                    <Form.Check
                      defaultChecked={mainH1 === true}
                      inline
                      label="Si"
                      name="mainH1"
                      type="radio"
                      onClick={() => setMainH1(true)}
                    />
                    <Form.Check
                      defaultChecked={mainH1 === false}
                      inline
                      label="No"
                      name="mainH1"
                      type="radio"
                      onClick={() => setMainH1(false)}
                    />
                  </div>
                </div>
              </div>
            </form>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default SidebarSlides;
